import { IconButton, styled } from "@mui/material"

export const StyledFilterButton = styled(IconButton)(({ theme }) => ({
  height: "32px",
  backgroundColor: theme.palette.grey[200],
  borderRadius: "28px",
  boxShadow: "none",
  fontSize: "0.9rem",
  fontFamily: "Inter",
  gap: "4px",
}))
